export const GET_SURVEY_DATA = "GET_SURVEY_DATA"
export const GET_TRANSACTION_ID = "GET_TRANSACTION_ID"
export const UPDATE_JSON_ANSWER = "UPDATE_JSON_ANSWER"
export const UPDATE_SURVEY_ANSWER_DATA = "UPDATE_SURVEY_ANSWER_DATA"
export const UPDATE_SAVE_ANSWER_DATA = "UPDATE_SAVE_ANSWER_DATA"